import { render, staticRenderFns } from "./T1CovidHeaderInfo.vue?vue&type=template&id=57b971db&scoped=true&"
import script from "./T1CovidHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./T1CovidHeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./T1CovidHeaderInfo.vue?vue&type=style&index=0&id=57b971db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b971db",
  null
  
)

export default component.exports